const enum IconNames {
	ICON_ARROW_RIGHT = 'icon-arrow-right',
	ICON_360_VIEW = 'icon-360-view',
	ACCESSORIES = 'Accessories',
	APP_DOWNLOAD = 'App_Download',
	ARROW_LEFT = 'Arrow_Left',
	APPROVED_USED = 'Approved_Used',
	ARROW_DOWN = 'Arrow_Down',
	BODYSHOP = 'Bodyshop',
	DRIVEONROAD = 'Driveonroad',
	IGNITE_CONFIGURE = 'Ignite_Configure',
	CAPACITY = 'Capacity',
	CAR_TAX_CALCULATORS = 'Car_Tax_Calculators',
	CAUTION = 'Caution',
	CLASSIC = 'Classic',
	CO2 = 'CO2',
	COMPARE = 'Compare',
	CONTACT_AND_HELP = 'Contact_And_Help',
	CONTACT_US = 'Contact_Us',
	CONTRACT_HIRE_CALCULATOR = 'Contract_Hire_Calculator',
	CHEVRON_RIGHT = 'Chevron_Right',
	CLOSE = 'Close',
	CREDIT_CARD = 'Credit_Card',
	DIRECTIONAL_RIGHT = 'Directional_Right',
	DOWNLOAD = 'Download',
	DOWNLOAD_BROCHURE = 'Download_Brochure',
	EDIT = 'Edit',
	EMAIL = 'Email',
	EVENTS = 'Events',
	EXPERIENCE = 'Experience',
	FAX = 'Fax',
	FILTER = 'Filter',
	FINANCE_CALCULATOR = 'Finance_Calculator',
	FIND_A_RETAILER = 'Find_A_Retailer',
	FUEL = 'Fuel',
	FULL_SCREEN = 'Full_Screen',
	GALLERY = 'Gallery',
	GUIDES_EVO_JAGUAR = 'Guides_Evo_Jaguar',
	INCONTROL = 'Incontrol',
	INFORMATION_LANDROVER = 'Information_Landrover',
	INSURANCE = 'Insurance',
	KEEP_ME_INFORMED = 'Keep_Me_Informed',
	LAND_ROVER_TO_YOU = 'Land_Rover_To_You',
	LINK = 'Link',
	LOCATION = 'Location',
	LOCATION_FILLED = 'Location_Filled',
	LOGIN = 'Login',
	CHAT = 'Chat',
	NEWS = 'News',
	NOTES = 'Notes',
	OFFERS_DOLLAR = 'Offers_Dollar',
	OFFERS_EURO = 'Offers_Euro',
	OWNERS = 'Owners',
	PARTS = 'Parts',
	PHONE = 'Phone',
	PHONE_BIG = 'phone-big',
	PRINT = 'Print',
	QUESTION_MARK = 'Question_Mark',
	REDUCE_VIEW = 'Reduce_View',
	REMINDERS = 'Reminders',
	REQUEST_QUOTE_DOLLAR = 'Request_Quote_Dollar',
	SAVE = 'Save',
	SEARCH = 'Search',
	SEARCH_INVENTORY = 'Search_Inventory',
	SECURE = 'Secure',
	SERVICE = 'Service',
	SERVICE_HISTORY = 'Service_History',
	SERVICE_RETAILER = 'Service_Retailer',
	SHARE = 'Share',
	SHOP = 'Shop',
	SHOW_PRICES = 'Show_Prices',
	SPECIAL_VEHICLE = 'Special_Vehicle',
	SVO = 'SVO',
	SPEED = 'Speed',
	TIME = 'Time',
	VEHICLE = 'Vehicle',
	VIDEO_GUIDES = 'Video_Guides',
	WARNING = 'Warning',
	BATTERY_ELECTRIC_VEHICLE = 'Battery_Electric_Vehicle',
	FAVOURITE = 'Favourite',
	FLEET_BUSINESS = 'Fleet_Business',
	LINK_OUT = 'Link_Out',
	PINNACLE = 'Pinnacle',
	PLUG_IN_HYBRID_ELECTRIC_VEHICLE = 'Plug-in_Hybrid_Electric_Vehicle',
	SEATS = 'Seats',
	VEHICLE_PRICE_DOLLAR = 'Vehicle_Price_Dollar',
	VEHICLE_PRICE_EURO = 'Vehicle_Price_Euro',
	REQUEST_A_QUOTE_EURO = 'Request_A_Quote_Euro',
	BUILD = 'Build',
	ICON_LR_APP = 'icon-LR_App',
	ICON_LR_FACEBOOK = 'icon-LR_Facebook',
	ICON_LR_INSTAGRAM = 'icon-LR_Instagram',
	ICON_LR_LINKEDIN = 'icon-LR_LinkedIn',
	ICON_LR_OFFER_CHF = 'icon-LR_Offer_CHF',
	ICON_LR_OFFER_CNY = 'icon-LR_Offer_CNY',
	ICON_LR_OFFER_CZK = 'icon-LR_Offer_CZK',
	ICON_LR_OFFER_GBP = 'icon-LR_Offer_GBP',
	ICON_LR_OFFER_INR = 'icon-LR_Offer_INR',
	ICON_LR_OFFER_JPY = 'icon-LR_Offer_JPY',
	ICON_LR_OFFER_KRW = 'icon-LR_Offer_KRW',
	ICON_LR_OFFER_RUB = 'icon-LR_Offer_RUB',
	ICON_LR_OFFER_ZAR = 'icon-LR_Offer_ZAR',
	ICON_LR_PIVOTAL = 'icon-LR_Pivotal',
	ICON_LR_SPECIAL_OFFERS = 'icon-LR_Special_Offers',
	ICON_LR_TRADE_IN = 'icon-LR_Trade_In',
	ICON_LR_TWITTER = 'icon-LR_Twitter',
	ICON_LR_USB = 'icon-LR_USB',
	ICON_LR_VEHICLE_HIRE = 'icon-LR_Vehicle_Hire',
	ICON_LR_VEHICLE_OFFER = 'icon-LR_Vehicle_Offer',
	ICON_LR_WECHAT = 'icon-LR_WeChat',
	ICON_LR_WEIBO = 'icon-LR_Weibo',
	ICON_LR_YOUTUBE = 'icon-LR_YouTube',
	ICON_APP = 'icon-App',
	ICON_FACEBOOK = 'icon-Facebook',
	ICON_INSTAGRAM = 'icon-Instagram',
	ICON_LINKEDIN = 'icon-LinkedIn',
	ICON_OFFER_CHF = 'icon-Offer_CHF',
	ICON_OFFER_CNY = 'icon-Offer_CNY',
	ICON_OFFER_CZK = 'icon-Offer_CZK',
	ICON_OFFER_GBP = 'icon-Offer_GBP',
	ICON_OFFER_INR = 'icon-Offer_INR',
	ICON_OFFER_JPY = 'icon-Offer_JPY',
	ICON_OFFER_KRW = 'icon-Offer_KRW',
	ICON_OFFER_RUB = 'icon-Offer_RUB',
	ICON_OFFER_ZAR = 'icon-Offer_ZAR',
	ICON_PIVOTAL = 'icon-Pivotal',
	ICON_SPECIAL_OFFERS = 'icon-Special_Offers',
	ICON_TRADE_IN = 'icon-Trade_In',
	ICON_TWITTER = 'icon-Twitter',
	ICON_USB = 'icon-USB',
	ICON_VEHICLE_HIRE = 'icon-Vehicle_Hire',
	ICON_VEHICLE_OFFER = 'icon-Vehicle_Offer',
	ICON_WECHAT = 'icon-WeChat',
	ICON_WEIBO = 'icon-Weibo',
	ICON_YOUTUBE = 'icon-YouTube',
	ICON_CLASSIC = 'icon-classic',
	CHEVRON_DOWN = 'Chevron_Down',
	WHATSAPP = 'whatsapp',
}

export default IconNames;
